import React from 'react';
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Img,
  Text,
} from '@chakra-ui/react';
import { useAppSelector } from '@/store';

const MemberHeroSection: React.FC<{
  title: string | React.ReactNode;
  desc?: string | React.ReactNode;
  type?: string;
}> = ({ title, desc, type }) => {
  const isLoggedIn = useAppSelector((state) => state.user?.isLoggedIn);
  return (
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={
        type === 'about-us'
          ? '350px'
          : type === 'our-team'
          ? '400px'
          : { xs: '100%', sm: '550px' }
      }
      minH={
        type === 'about-us'
          ? '350px'
          : type === 'our-team'
          ? '400px'
          : { xs: '610px', sm: '550px' }
      }
      maxH={
        type === 'about-us'
          ? '350px'
          : type === 'our-team'
          ? '496px'
          : { xs: '800px', sm: '550px' }
      }
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src={
          type === 'about-us'
            ? '/webp/citySkyline.webp'
            : type === 'our-team'
            ? '/webp/ourTeamBanner.webp'
            : '/svg/member-hero.svg'
        }
        alt="hero background image"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        // eslint-disable-next-line no-constant-condition
        opacity={type === 'about-us' || 'our-team' ? '0.55' : '0.7'}
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
        py={type === 'membership' ? { xs: '16px', sm: '0px' } : '0px'}
      >
        {typeof title === 'string' ? (
          <Heading
            as="h1"
            variant="headingText"
            color="text.headingWhite"
            fontSize={
              // eslint-disable-next-line no-constant-condition
              type === 'about-us' || 'our-team' || 'membership'
                ? { xs: '50px', sm: '60px', md: '74px' }
                : { xs: '38px', sm: '48px', lg: '54px' }
            }
            textAlign={
              // eslint-disable-next-line no-constant-condition
              type === 'about-us' || 'our-team'
                ? { xs: 'center', sm: 'left' }
                : 'left'
            }
          >
            {title}
          </Heading>
        ) : (
          title
        )}
        {typeof desc === 'string' ? (
          <Text
            as="p"
            maxW="900px"
            variant="contentText"
            pt="16px"
            textAlign={
              // eslint-disable-next-line no-constant-condition
              type === 'about-us' || 'our-team'
                ? { xs: 'center', sm: 'left' }
                : 'left'
            }
          >
            {desc}
          </Text>
        ) : (
          desc
        )}
        {!isLoggedIn && (
          <Flex
            pt="33px"
            flexDir={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'center', sm: 'flex-start' }}
          >
            {type !== 'about-us' && (
              <Button
                as="a"
                rel="noreferrer"
                href={
                  type === 'about-us'
                    ? '/our-team'
                    : type === 'our-team'
                    ? '/about-us'
                    : '#'
                }
                aria-label={type}
                mr={{ xs: '0px', sm: '10px' }}
                mb={{ xs: '20px', sm: '0px' }}
                borderRadius="0"
                fontSize="18px"
                fontWeight="700"
                color="text.textBlue"
                p="20px 34px 20px 34px"
                w={{ xs: '100%', sm: '187px' }}
              >
                {type === 'about-us'
                  ? 'Our Team'
                  : type === 'our-team'
                  ? 'Know More'
                  : 'Member Login'}
              </Button>
            )}

            {type === 'membership' && (
              <Button
                as="a"
                rel="noreferrer"
                href="/membership/membership-form"
                aria-label="Become a Member"
                borderRadius="0"
                w={{ xs: '100%', sm: '220px' }}
                fontSize="18px"
                fontWeight="700"
                color="text.headingWhite"
                bg="transparent"
                border="0.5px solid white"
                p="20px 34px 20px 34px"
                _hover={{ opacity: '0.85' }}
              >
                Become a Member
              </Button>
            )}
          </Flex>
        )}
      </Container>
    </Flex>
  );
};

export default MemberHeroSection;
